import { getlocalStorageLang } from '@/i18n'
import { LANG_TYPE } from '@/i18n/langType'
import { State } from './state'

const getters = {
  // 言語情報の取得
  language: (state: State) => {
    // vuexにデータがある場合はvuexのデータを返す
    if (state.header.language) {
      return state.header.language
    }
    return getlocalStorageLang()
  },
  /**
   * ログイン状態を取得する
   * @param state vuexのState情報
   * @returns true:ログイン中、false:ログイン中でない
   */
  loginstatus: (state: State) => state.login.status,
  /**
   * ユーザー表示名の取得
   * @param state vuexのState情報
   * @returns ユーザー表示名
   */
  dispUsername: (state: State) => {
    const name = state.login.usernamedisp
    if (name) {
      return name
    }
    return ''
  },
  /**
   * ユーザー表示名最初の文字を取得
   * @param state vuexのState情報
   * @returns ユーザー表示名の最初の文字
   */
  dispUsernameFirst: (state: State) => {
    const name = state.login.usernamedisp
    if (name) {
      return name.substring(0, 1).toUpperCase()
    }
    return ''
  },
  /**
   * CSRFトークンの取得
   * @param state vuexのState情報
   * @returns CSRFトークン 未設定の場合は空を返す
   */
  csrfToken: (state: State) => {
    // csrfトークンが設定されていない場合は空を返す、それ以外は設定しているcsrftokenを返す
    if (!state.login.csrftoken) {
      return ''
    }
    return state.login.csrftoken
  },
  /**
   * 認証情報の取得有無
   * @param state vuexのState情報
   * @returns true:認証済み、false:未認証
   */
  authinfocheck: (state: State) => {
    // vuexの認証情報に設定されていない場合はfalseを返す
    const { login } = state
    if (!login.status || !login.username || !login.usernamedisp || !login.csrftoken) {
      return false
    }
    // 認証情報が設定されている場合はtrueを返す
    return true
  },
  /**
   * ヘッダーのアカウント表示有無を取得する
   * @param state vuexのState情報
   * @returns true:表示、false:非表示
   */
  headerAccount: (state: State) => state.header.disp.username,
  /**
   * ヘッダーの言語設定表示有無を取得する
   * @param state vuexのState情報
   * @returns true:表示、false:非表示
   */
  headerLang: (state: State) => state.header.disp.lang,
  /**
   * ヘッダーのヘルプ表示有無を取得する
   * @param state vuexのState情報
   * @returns true:表示、false:非表示
   */
  headerHelp: (state: State) => state.header.disp.help,
  /**
   * ヘッダーのログアウトボタン表示有無を取得する
   * @param state vuexのState情報
   * @returns true:表示、false:非表示
   */
  headerLogout: (state: State) => state.header.disp.logout,
  /**
   * ヘッダーのメニュー表示有無を取得する
   * @param state vuexのState情報
   * @returns true:表示、false:非表示
   */
  headerMenu: (state: State) => state.header.disp.menu,
  /**
   * 現在選択中のメニューを取得する
   * @param state vuexのState情報
   * @returns 選択中のメニュー
   */
  selectMenu: (state: State) => state.menu.selected,
  /**
   * ダウンロード詳細情報検索有無を取得する
   * @param state vuexのState情報
   * @returns true:検索済み、false:検索していない
   */
  downloadSearch: (state: State) => state.screen.download.search,
  /**
   * ダウンロード詳細情報を取得する
   * @param state vuexのState情報
   * @returns ダウンロード詳細情報
   */
  downloadDetail: (state: State) => state.screen.download.detail,
  /**
   * ダウンロード詳細情報の添付ファイル有無を取得する
   * @param state vuexのState情報
   * @returns true:添付ファイル有り、false:添付ファイル
   */
  downloadAttached: (state: State) => state.screen.download.detail.attached.length !== 0,
  /**
   * ダウンロード詳細情報の失敗有無を取得する
   * @param state vuexのState情報
   * @returns true:有り、false:無し
   */
  downloadDetailFail: (state: State) => state.screen.download.detail.isFail,
  /**
   * 他画面情報かを判定する 現状はヘルプのみ
   * @param state vuexのState情報
   * @returns true:他画面情報、false:他画面情報でない
   */
  isOtherStatus: (state: State) => state.other,
  /**
   * 現在の言語が日本語であるかを判定する
   * @param _state vuexのState情報
   * @returns true:日本語、false:日本語以外
   */
  isJapanese: (_state: State, rootGetters: { language: string }) => {
    // 現在の言語を取得（すでに定義されているgettersのlanguageを使用）
    const currentLang = rootGetters.language
    // 日本語であるかを判定して返す
    return currentLang === LANG_TYPE.JA
  },
}

export { getters }
